import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';

import { actions, selectors } from './';

import { renderDefaultTD } from '../../../shared/new-table/renderers';

import renderViewsState from '../../../shared/render-views-state';
import Animate from '../../../shared/animation';
import Table from '../../../shared/new-table/main';
import table from '../list/table-initial-data';
import PageContainer from '../../../shared/page-container/main';
import tabs from '../../tabs';

const Main = renderViewsState(
	props => (
		<Animate>
			<PageContainer name='BM accounts' tabs={tabs}>
				<div className="bm-accounts">
					{props.can('edit') && (
						<div className='bm-accounts-navigation'>
							<Link
								className='ui-btn ui-btn-primary'
								to='/bm-accounts/categories/edit'
							>
								{props.intl('Create BM accounts category')}
							</Link>
						</div>
					)}
					{props.data && !!props.data.length &&
						<Table
							className='bm-accounts-table'
							table={table}
							rows={props.data}
							renderTD={createRenderTD(false, props.removeById, props.can)}
						/>
					}
				</div>
			</PageContainer>
		</Animate>
	)
);

function createRenderTD(check, removeById, can) {
	return function ({ index, column }, props) {
		if (index === 'actions') {
			return (
				<td className={column.className} key={index}>
					<div className='goods-actions'>
						{can('edit') && (
							<Link
								className='banners-edit-icon'
								to={`/bm-accounts/categories/edit/${props.row.id}`}
							/>
						)}
						{can('edit') && (
							<a
								className='bm-accounts-remove-icon'
								onClick={() => {removeById(props.row.id);}}
							/>
						)}
					</div>
				</td>
			);
		}

		return renderDefaultTD({ index, column }, props);
	};
}

function mapStateToProps(state) {
	return {
		data: selectors.select(state, 'data', null),
		intl: selectors.getIntl(state),
		isLoading: selectors.select(state, 'isLoading'),
		can: selectors.getCan(state),
		isError: selectors.select(state, 'isError')
	};
}

export default connect(mapStateToProps, actions)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/category/list/main.js